var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDecoLineAbout2Inline = function SvgDecoLineAbout2Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 277,
    viewBox: "0 0 160 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 708",
    d: "M152.869 43.209h-35.867L-54.193 276.756h35.867L152.87 43.209Z",
    fill: "#D90718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 709",
    d: "M134.14 6.381h-26.13L45.534 91.888h26.13L134.14 6.38Z",
    fill: "#092140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 720",
    d: "M159.117 0h-4.129l-21.395 30.63h4.129L159.117 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 723",
    d: "M69.782 48.496h-4.128L32.772 91.887h4.13l32.88-43.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 722",
    d: "M125.024 102.097h-4.129l-25.224 34.458h4.13l25.223-34.458Z",
    fill: "#D90718"
  }))));
};
export default SvgDecoLineAbout2Inline;